import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";
import {Metadata} from "@/common/Metadata";

export class ConfigModel extends BaseObject {

    constructor(group, mapId) {
        super();

        this._group = group;
        this._tag = null;
        this._meta = null;
        this._deployed = false;
        this._info = ""
        this._historyId = null;
        this._mapId = mapId;
        this._groupId = null;

        this._marker = null;
        this._mapId = this._mapId || 0;
        this._sharedConfig = null;
    }

    get historyId() {
        return this._historyId;
    }

    set historyId(value) {
        this._historyId = value;
    }

    get group() {
        return this._group;
    }

    set group(value) {
        this._group = value;
    }

    get info() {
        return this._info;
    }

    set info(value) {
        this._info = value;
    }

    get tag() {
        return this._tag;
    }

    set tag(value) {
        this._tag = value;
    }

    get meta() {
        return this._meta;
    }

    set meta(value) {
        this._meta = value;
    }

    get deployed() {
        return this._deployed;
    }

    set deployed(value) {
        this._deployed = value;
    }

    get mapId() {
        return this._mapId;
    }

    set mapId(value) {
        this._mapId = value;
    }

    get marker() {
        return this._marker;
    }

    set marker(value) {
        this._marker = value;
    }

    get groupId() {
        return this._groupId;
    }

    set groupId(value) {
        this._groupId = value;
    }

    get sharedConfig() {
        return this._sharedConfig;
    }

    set sharedConfig(value) {
        this._sharedConfig = value;
    }

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ConfigModel());
        } else if (target instanceof ConfigModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }

    static schema() {
        return custom((v) => {
            return v ? serialize(ConfigModel, v) : SKIP;
        }, (v) => {
            return deserialize(ConfigModel, v);
        });
    }
}

createModelSchema(ConfigModel, {
    _uid: alias("uid", Schema.primitive()),
    _group: alias("group", Schema.primitive()),
    _tag: alias("tag", Schema.primitive()),
    _meta: alias("meta", Metadata.schema()),
    _deployed: alias("deployed", Schema.primitive()),
    _info: alias("info", Schema.primitive()),
    _historyId: alias("historyId", Schema.primitive()),
    _mapId: alias("mapId", Schema.primitive()),
    _marker: alias("marker", Schema.primitive()),
    _groupId: alias("groupId", Schema.primitive()),
    _sharedConfig: alias("sharedConfig", Schema.primitive()),
});